<template>
  <div class="main">
    <section class="panel panel-default" style="margin-bottom: 0px;">
      <header class="panel-heading" style="padding: 10px;">
        <div class="panel-actions" style="top: 7px;">
          <a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
        </div>
        <h4 class="panel-title">查詢條件</h4>
      </header>
      <div id="searchArea" class="panel-collapse collapse">
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-12">
              <div class="col-md-3">
                <label class="col-md-4">學年</label>
                <div class="col-md-8">
                  <select v-model="query.schYear" class="form-control">
                    <option value="">--請選擇--</option>
                    <option v-for="(item, index) in schoolYearList" :key="index" :value="item">{{ item }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label class="col-md-4">學期</label>
                <div class="col-md-8">
                  <select v-model="query.smtr" class="form-control">
                    <option value="">--請選擇--</option>
                    <option value="1">第一學期</option>
                    <option value="2">第二學期</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label class="col-md-4">身份別</label>
                <div class="col-md-8">
                  <select v-model="query.identityType" class="form-control">
                    <option value="">--請選擇--</option>
                    <option value="組長">組長</option>
                    <option value="輔導人員">輔導人員</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12">
              <div class="col-md-3">
                <label class="col-md-4">帳號</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" v-model="query.account" />
                </div>
              </div>
              <div class="col-md-3">
                <label class="col-md-4">姓名</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" v-model="query.tutorName" />
                </div>
              </div>
              <div class="col-md-offset-2 col-md-4">
                <div class="col-md-offset-2 col-md-8">
                  <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="tab-content">
      <div class="row form-group">
        <div class="col-md-12 text-right form-inline">
          <label for="tutorExcel">
            <div style="display:none;">
              <input type="file" id="tutorExcel" name="tutorExcel" @change="impTutorRoster($event)" />
            </div>
            <a class="btn btn-danger">資料匯入</a>
            <a href="javascript:;" target="_blank" class="btn btn-danger" @click="downloadFile('宿舍輔導人員匯入範本.xlsx')">宿舍輔導人員匯入範本</a>
          </label>
        </div>
        <div class="col-md-12 text-right">
          <small class="text-muted">匯入提示：身份別僅限輸入「組長」或「輔導人員」。</small>
        </div>
      </div>

      <div class="tab-pane fade in show" role="tabpanel" aria-labelledby="tutor-tab">
        <div class="row">
          <div class="col-md-12">
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center" width="8%">序號</th>
                  <th class="text-center" width="12%">學年</th>
                  <th class="text-center" width="10%">學期</th>
                  <th class="text-center" width="20%">帳號</th>
                  <th class="text-center" width="20%">宿舍輔導人員</th>
                  <th class="text-center" width="12%">
                    身份別
                    <div><small class="text-muted">僅限組長/輔導人員</small></div>
                  </th>
                  <th class="text-center" width="18%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tutorGrid" :key="index">
                  <td class="text-center" data-title="序號">{{ (page - 1) * pageSize + index + 1 }}</td>
                  <td class="text-center" data-title="學年">{{ item.schYear }}</td>
                  <td class="text-center" data-title="學期">{{ item.smtr }}</td>
                  <td class="text-center" data-title="帳號">{{ item.account }}</td>
                  <td class="text-center" data-title="宿舍輔導人員">{{ item.tutorName }}</td>
                  <td class="text-center" data-title="身份別">{{ item.identityType }}</td>
                  <td class="text-center" data-title="">
                    <a class="btn btn-link" @click="delTutor(item)">刪除</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <div class="text-center" v-if="isAdmin('stay')">
              <pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tutorGrid: [],
      page: 1,
      pageSize: 10,
      totalPage: 0,
      query: {
        schYear: "",
        smtr: "",
        account: "",
        tutorName: "",
        identityType: ""
      }
    };
  },
  computed: {
    schoolYearList() {
      const now = new Date();
      let year = now.getFullYear() - 1911;
      if (now.getMonth() + 1 < 8) {
        year -= 1;
      }
      const list = [];
      for (let y = year; y > 111; y--) {
        list.push(String(y));
      }
      return list;
    }
  },
  mounted() {
    if (this.sessionData == null) {
      this.$router.replace({ path: "/" });
      return;
    }
    this.pageInit();
  },
  methods: {
    updateGrid(page) {
      this.page = page;
      this.pageInit();
    },
    pageInit() {
      const api = "/api/RoomMage/tutorGrid";
      const param = {
        page: this.page,
        pageSize: this.pageSize,
        model: this.query
      };
      this.$axios.post(api, JSON.stringify(param)).then(resp => {
        this.tutorGrid = resp.data.data.rows || [];
        this.totalPage = resp.data.data.total;
      });
    },
    impTutorRoster(e) {
      const api = "/api/RoomMage/impTutorRoster";
      if (e.target.files.length > 0) {
        const excelFile = e.target.files[0];
        const formData = new FormData();
        formData.append("file", excelFile);
        this.$axios.post(api, formData).then(resp => {
          bootbox.alert(resp.data.msg.replace(new RegExp(/\r?\n/, "g"), "<br />"), () => {
            if (resp.data.status === "success") {
              this.pageInit();
            }
          });
        });
        e.target.value = "";
      }
    },
    delTutor(item) {
      bootbox.confirm("確定刪除此筆?", result => {
        if (!result) {
          return;
        }
        const api = `/api/RoomMage/delTutor/${item.schYear}/${item.smtr}/${item.account}`;
        this.$axios.delete(api).then(resp => {
          bootbox.alert(resp.data.msg, () => {
            if (resp.data.status === "success") {
              this.pageInit();
            }
          });
        });
      });
    }
  }
};
</script>
